import {
  Button,
  Checkbox,
  Container,
  Distribute,
  List,
  ListRow,
  Switch,
  Text,
} from '@loomhq/lens';
import _isEmpty from 'lodash/isEmpty';
import Mousetrap from 'mousetrap';
import React from 'react';
import { connect } from 'react-redux';

import { SHARE_VIDEO_SETTINGS_UPDATED } from 'constants/events';
import { ESCAPE_LITERAL } from 'constants/keyCodes';
import { KEY_UP } from 'constants/keyEvents';
import { CAM } from 'constants/recordingTypes';
import { updateVideoSettings } from 'creators/shareVideo';
import { patchUserVideoSettings } from 'creators/user';
import * as analytics from 'utilities/analytics';

import VideoSectionCard from '../video-section-card';
import { CUSTOM_BRANDING_ACCESS } from '../../../../../shared/constants/scopes';
import { THUMB_GIF } from '../../../../../shared/constants/video';

import Scopes from 'components/scopes';

import './styles.less';

class VideoSettings extends React.Component {
  static defaultProps = {
    onCancelClick: () => {},
    onSaveClick: () => {},
  };

  state = {
    comments_email_enabled: true,
    comments_enabled: true,
    download_enabled: true,
    loom_branded_player: true,
    loom_branded_player_default: false,
    use_emojis: true,
    use_emojis_default: false,
    use_gif_default: false,
    use_gif: false,
    flipped_camera: true,
    show_analytics_to_viewer: true,
    original_comments_email_enabled: true,
    original_comments_enabled: true,
    original_download_enabled: true,
    original_flipped_camera: true,
    original_show_analytics_to_viewer: true,
  };

  render() {
    const { video, validationError, onCancelClick } = this.props;

    if (video == null) {
      return null;
    }

    const {
      comments_email_enabled,
      comments_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      loom_branded_player_default,
      use_emojis_default,
      use_emojis,
      use_gif_default,
      use_gif,
    } = this.state;

    const hasGif = video.thumbnails[THUMB_GIF];
    const isCameraRecording =
      (video.video_properties || {}).screen_type === CAM;

    const listRowPadding = 'medium';

    return (
      <VideoSectionCard className="edit-video-settings">
        <div className="mb:medium">
          <Distribute gap="auto">
            <Text variant="title">Settings</Text>
            <span className="navigation-close" onClick={onCancelClick} />
          </Distribute>
        </div>
        <List columns={['1fr', 'auto']} gap="small">
          <ListRow padding={listRowPadding}>
            Comments
            <Switch
              index="comments-enabled"
              isActive={comments_enabled}
              onClick={this.toggleCommentsEnabled}
            />
          </ListRow>
          <ListRow padding={listRowPadding}>
            Comment email notifications
            <Switch
              index="comments-email-enabled"
              isActive={comments_email_enabled}
              onClick={this.togglecommentsEmailEnabled}
            />
          </ListRow>

          <ListRow padding={listRowPadding}>
            Emoji Reactions
            <Switch
              index="use-emojis"
              isActive={use_emojis}
              onClick={this.toggleProp('use_emojis')}
            />
            <div
              className="video-settings-setting-fullwidth"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleProp('use_emojis_default')();
              }}
            >
              <Checkbox
                isChecked={use_emojis_default}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  // this is flaky without setTimeout
                  setTimeout(this.toggleProp('use_emojis_default'), 0);
                }}
              />
              <label className="ml:small">Make default setting</label>
            </div>
          </ListRow>
          {/* for basic users, only show gif options if a gif has been generated */}
          {hasGif && (
            <ListRow padding={listRowPadding}>
              Animated Thumbnail (gif)
              <Switch
                index="use-gif"
                isActive={use_gif}
                onClick={this.toggleProp('use_gif')}
              />
              <div
                className="video-settings-setting-fullwidth"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.toggleProp('use_gif_default')();
                }}
              >
                <Checkbox
                  isChecked={use_gif_default}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    // this is flaky without setTimeout
                    setTimeout(this.toggleProp('use_gif_default'), 0);
                  }}
                />
                <label className="ml:small">Make default setting</label>
              </div>
            </ListRow>
          )}
          <Scopes names={CUSTOM_BRANDING_ACCESS}>
            <ListRow padding={listRowPadding}>
              Loom Branded Player
              <Switch
                index="show-end-of-video-screen"
                isActive={loom_branded_player}
                onClick={this.toggleProp('loom_branded_player')}
              />
              <div
                className="video-settings-setting-fullwidth"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.toggleProp('loom_branded_player_default')();
                }}
              >
                <Checkbox
                  isChecked={loom_branded_player_default}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    // this is flaky without setTimeout
                    setTimeout(
                      this.toggleProp('loom_branded_player_default'),
                      0
                    );
                  }}
                />
                <label className="ml:small">Make default setting</label>
              </div>
            </ListRow>
          </Scopes>
          <ListRow padding={listRowPadding}>
            Viewer can download
            <Switch
              index="download-enabled"
              isActive={download_enabled}
              onClick={this.toggleProp('download_enabled')}
            />
          </ListRow>
          <ListRow padding={listRowPadding}>
            Show analytics to viewer
            <Switch
              index="analytics-to-viewer"
              isActive={show_analytics_to_viewer}
              onClick={this.toggleProp('show_analytics_to_viewer')}
            />
          </ListRow>
          {isCameraRecording && (
            <ListRow padding={listRowPadding}>
              Flip camera
              <Switch
                index="flipped-camera"
                isActive={flipped_camera}
                onClick={this.toggleProp('flipped_camera')}
              />
            </ListRow>
          )}
          <div className="flex width:full mt:large">
            {validationError && (
              <span className="validation-error">
                Oops! Could not update settings
              </span>
            )}
            <Container width="100%">
              <Button
                hasFullWidth
                variant="primary"
                onClick={this.handleSaveClick}
              >
                Save preferences
              </Button>
            </Container>
          </div>
        </List>
      </VideoSectionCard>
    );
  }

  componentDidMount() {
    const {
      video: {
        comments_email_enabled,
        comments_enabled,
        download_enabled,
        flipped_camera,
        show_analytics_to_viewer,
        loom_branded_player = true,
        use_emojis = true,
        use_gif = false,
      },
    } = this.props;

    this.setState({
      comments_email_enabled,
      comments_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      use_emojis,
      use_gif,
      original_comments_email_enabled: comments_email_enabled,
      original_comments_enabled: comments_enabled,
      original_download_enabled: download_enabled,
      original_flipped_camera: flipped_camera,
      original_show_analytics_to_viewer: show_analytics_to_viewer,
    });

    Mousetrap.bind(ESCAPE_LITERAL, this.props.onCancelClick, KEY_UP);
  }

  componentWillUnmount() {
    Mousetrap.unbind(ESCAPE_LITERAL, KEY_UP);
  }

  toggleProp = prop => () => {
    this.setState({ [prop]: !this.state[prop] });
  };

  handleUpdatePassword = password => {
    this.setState({ password, password_err: null });
  };

  toggleCommentsEnabled = () => {
    const { comments_enabled } = this.state;

    window.setTimeout(() => {
      this.setState({ comments_email_enabled: !comments_enabled });
    }, 200);

    this.setState({ comments_enabled: !comments_enabled });
  };

  togglecommentsEmailEnabled = () => {
    const { comments_enabled, comments_email_enabled } = this.state;

    if (!comments_enabled && !comments_email_enabled) {
      return;
    }

    this.setState({
      comments_email_enabled: !this.state.comments_email_enabled,
    });
  };

  handleSaveClick = () => {
    const {
      comments_enabled,
      comments_email_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      loom_branded_player_default,
      use_emojis,
      use_emojis_default,
      use_gif,
      use_gif_default,
    } = this.state;

    const {
      video,
      onSaveClick,
      updateVideoSettings,
      updateDefaultVideoSettings,
    } = this.props;

    const hasChanged = prop =>
      this.state[prop] !== this.state[`original_${prop}`];

    analytics.track(SHARE_VIDEO_SETTINGS_UPDATED, {
      comments_enabled,
      comments_email_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      use_emojis,
      use_emojis_default,
      loom_branded_player,
      loom_branded_player_default,
      video_id: video.id,
      comments_enabled_changed: hasChanged('comments_enabled'),
      comments_email_enabled_changed: hasChanged('comments_email_enabled'),
      download_enabled_changed: hasChanged('download_enabled'),
      flipped_camera_changed: hasChanged('flipped_camera'),
      show_analytics_to_viewer_changed: hasChanged('show_analytics_to_viewer'),
      use_emojis_default_changed: hasChanged('use_emojis_default'),
      loom_branded_player_default_changed: hasChanged(
        'loom_branded_player_default'
      ),
    });

    updateVideoSettings({
      comments_enabled,
      comments_email_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      use_emojis,
      use_gif,
    });

    let defaultVideoSettings = {};

    if (use_emojis_default) {
      defaultVideoSettings = {
        ...defaultVideoSettings,
        use_emojis,
      };
    }

    if (use_gif_default) {
      defaultVideoSettings = {
        ...defaultVideoSettings,
        use_gif,
      };
    }

    if (loom_branded_player_default) {
      defaultVideoSettings = {
        ...defaultVideoSettings,
        loom_branded_player,
      };
    }

    if (!_isEmpty(defaultVideoSettings)) {
      updateDefaultVideoSettings(defaultVideoSettings);
    }

    onSaveClick();
  };
}

const mapStateToProps = state => {
  const {
    settings_modal_err: validationError,
    show_pw_settings_modal: show,
    video,
  } = state.share_video;

  return {
    show,
    validationError,
    video,
  };
};

const mapDispatchToProps = dispatch => ({
  updateDefaultVideoSettings: settings =>
    dispatch(patchUserVideoSettings(settings)),
  updateVideoSettings: (newSettings, password) =>
    dispatch(updateVideoSettings(newSettings, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoSettings);
